import React from 'react';
import { ResponsiveBar } from '@nivo/bar';
import numeral from 'numeral';

const BalanceGraph = ({ data }) => {
    // Prepare data for the bar chart
    const barData = data.map(({ year, equity, liabilities }) => ({
        year,
        Equity: equity,
        Liabilities: liabilities,
    }));

    return (
        <div className="board-chart">
            <ResponsiveBar
                data={barData}
                keys={['Equity', 'Liabilities']}
                indexBy="year"
                margin={{ top: 24, right: 20, bottom: 44, left: 58 }}
                padding={0.3}
                colors={{ scheme: 'nivo' }}
                axisTop={null}
                axisBottom={{
                    tickSize: 5,
                    tickPadding: 5,
                    tickRotation: 0,
                    legend: 'Year',
                    legendPosition: 'middle',
                    legendOffset: 32,
                }}
                axisLeft={{
                    tickSize: 5,
                    tickPadding: 5,
                    tickRotation: 0,
                    format: (value) => numeral(value).format('$0.0a'),
                    legend: 'Amount',
                    legendPosition: 'middle',
                    legendOffset: -65,
                }}
                animate={true}
                motionStiffness={90}
                motionDamping={15}
                enableLabel={false}
                enableTotals={false}
                labelTextColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
                // Specify label formatting using `valueFormat`
                valueFormat={(value) => numeral(value).format('$0.0a')}
            />
        </div>
    );
};

export default BalanceGraph;
